import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { StyledAppointmentsSessionHeader } from "../../../../../styled/appointments";

const AppointmentSessionHeader = ({ appointment, siniestro, trabajador }) => {
  const professionalSpecialties = useSelector(
    (state) => state.forms.professionalSpecialties,
  );

  const getEspecialidad = (appointment) => {
    const especialidad = professionalSpecialties.data.find(
      (s) => s.id === appointment.especialidad,
    );
    return especialidad ? especialidad.nombre : "";
  };

  return (
    <StyledAppointmentsSessionHeader.Container elevation={2}>
      <Typography variant="body2">
        <b>
          Los Turnos ingresados a continuación corresponden al Siniestro{" "}
          {siniestro} {trabajador}.
        </b>
      </Typography>
      <Typography variant="body2">
        <b>
          Para el Profesional {appointment.profesionalApellidoNombre}{" "}
          {getEspecialidad(appointment)}.
        </b>
      </Typography>

      <StyledAppointmentsSessionHeader.Body variant="body2">
        <b>
          Usted puede modificar individualmente la Hora de Citación de cada uno
          de ellos y si corresponde coordinar traslados.
        </b>
      </StyledAppointmentsSessionHeader.Body>
    </StyledAppointmentsSessionHeader.Container>
  );
};

export default AppointmentSessionHeader;
